import React, {useState} from 'react';
import {colors, radii, transitions} from '../../common/theme';

interface CheckboxProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  disabledTooltip?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({label, checked, onChange, disabled, disabledTooltip}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        cursor: disabled ? 'not-allowed' : 'pointer',
        userSelect: 'none',
        marginBottom: '20px',
        position: 'relative',
      }}
      onMouseEnter={() => { if (disabled) setShowTooltip(true); }}
      onMouseLeave={() => setShowTooltip(false)}
      onClick={() => !disabled && onChange(!checked)}>

      {showTooltip && disabledTooltip && (
        <div style={{
          position: 'absolute',
          bottom: 'calc(100% + 8px)',
          left: 0,
          backgroundColor: '#1a1a1a',
          border: '1px solid #444',
          color: '#fff',
          fontSize: '0.78rem',
          lineHeight: '1.4',
          padding: '8px 12px',
          borderRadius: '8px',
          maxWidth: 280,
          zIndex: 100,
          boxShadow: '0 4px 12px rgba(0,0,0,0.5)',
          pointerEvents: 'none',
        }}>
          {disabledTooltip}
        </div>
      )}

      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          width: 20,
          height: 20,
          borderRadius: radii.sm,
          border: `2px solid ${disabled && checked ? colors.primaryDisabledBorder : disabled ? '#3a3a3a' : checked ? colors.primary : isHovered && !disabled ? colors.borderHover : colors.borderMuted}`,
          backgroundColor: disabled && checked ? colors.primaryDisabledBg : disabled ? colors.surface : checked ? colors.primary : 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          transition: `border-color ${transitions.normal}, background-color ${transitions.normal}`,
        }}>
        {checked && (
          <span style={{color: disabled ? colors.primaryDisabledFg : '#000', fontSize: '0.7rem', fontWeight: 700}}>
            ✓
          </span>
        )}
      </div>
      <span
        style={{
          display: 'block',
          color: disabled ? colors.textDisabled : colors.textMuted,
          fontSize: '0.75rem',
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
        }}>
        {label}
      </span>
    </div>
  );
};

